import { render, staticRenderFns } from "./AcademyProblemInput.vue?vue&type=template&id=9cab7fda&scoped=true&lang=pug&"
import script from "./AcademyProblemInput.vue?vue&type=script&lang=ts&"
export * from "./AcademyProblemInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cab7fda",
  null
  
)

export default component.exports